import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { queryClient } from '../config/query-client';

export type AppLanguageCode = 'pl' | 'en' | 'uk';

interface AdminLanguageState {
  language: AppLanguageCode;
  setLanguage: (language: AppLanguageCode) => void;
}

export const useAdminLanguageStore = create<AdminLanguageState>()(
  persist(
    (set, get) => ({
      language: 'en',
      setLanguage: (language) => {
        if (get().language === language) return;
        set({ language });

        // Đổi ngôn ngữ là ĐỔI DỮ LIỆU, không chỉ đổi nhãn giao diện.
        //
        // `getLanguage` ở config/api.ts đẩy ngôn ngữ vào header Accept-Language,
        // nên tên sản phẩm, tên danh mục và message của BE đều trả về theo
        // ngôn ngữ đang chọn. Nhưng query key KHÔNG chứa ngôn ngữ, và
        // `refetchOnMount: false` — nên nếu không dọn ở đây thì React Query
        // phục vụ lại đúng cache của ngôn ngữ cũ: chữ giao diện đổi ngay còn
        // tên sản phẩm thì đứng im, trông hệt như bản dịch chưa được lưu.
        //
        // Dọn TẤT CẢ chứ không riêng products: danh mục, NCC, cửa hàng, thông
        // báo lỗi — mọi thứ server trả về đều bám Accept-Language.
        queryClient.invalidateQueries();
      },
    }),
    {
      name: 'conai-admin-language',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export const selectAdminLanguage = (state: AdminLanguageState) => state.language;
